import { useTranslation } from 'react-i18next'
import Status from '@ui/elements/Status'
import {
  getOrderPaymentOverview,
  isValidOrderPaymentStatusValue,
  isValidOrderStatusValue,
  OrderPaymentOverview,
  OrderPaymentStatus,
} from '@ca/common/types'
import { ErpOrderHistoryItem } from '@ca/common/types'
import { usePriceFormatter } from 'hooks/useCurrency'

import {
  orderPaymentOverviewToVariant,
  orderPaymentStatusToVariant,
  orderStatusToVariant,
} from './styles'

interface Props {
  data: ErpOrderHistoryItem
}

export const OrderStatusBadge = ({ data }: Props) => {
  const { t } = useTranslation(['order'])

  const statusVariant = isValidOrderStatusValue(data.status)
    ? orderStatusToVariant[data.status]
    : 'neutral'

  const statusText = isValidOrderStatusValue(data.status)
    ? t(`order:order.status.values.${data.status}`)
    : data.status

  return <Status text={statusText} variant={statusVariant} />
}

export const useOrderDetailsPayment = (
  data: ErpOrderHistoryItem
): {
  total: number
  display: string
  paid: number
  status: OrderPaymentOverview
  hasDeclined: boolean
} => {
  const formatter = usePriceFormatter()
  const { total, paid, status, hasDeclined } = getOrderPaymentOverview(
    data.items,
    data.payments
  )
  const display = formatter.format(total)

  return {
    total,
    display,
    paid,
    status,
    hasDeclined,
  }
}

export const OrderPaymentOverviewBadge = ({ data }: Props) => {
  const { t } = useTranslation(['order'])
  const { status } = useOrderDetailsPayment(data)

  return (
    <Status
      text={t(`order:payment.status.overview.${status}`)}
      variant={orderPaymentOverviewToVariant[status]}
    />
  )
}

export const OrderPaymentStatusBadge = (props: {
  status: string
  className?: string
}) => {
  const { t } = useTranslation(['order'])

  const isValid = isValidOrderPaymentStatusValue(props.status)

  const status: OrderPaymentStatus = isValidOrderPaymentStatusValue(
    props.status
  )
    ? props.status
    : 'unknown'

  return (
    <Status
      text={isValid ? t(`order:payment.status.values.${status}`) : props.status}
      variant={orderPaymentStatusToVariant[status]}
      className={props.className}
    />
  )
}
